var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CardCvcElement, CardExpiryElement, CardNumberElement, } from '@stripe/react-stripe-js';
import { Spacer } from 'components/base';
import { colors } from 'components/UI-helpers/colors';
import { CardholderNameElement, ElementTray, FieldText, FieldWrapper, } from './style';
import { PaymentText } from '../../components/base';
var stripeElementOptions = {
    style: {
        base: {
            fontSize: '16px',
            color: colors.appexFontDefault,
            '::placeholder': {
                color: colors.smoke,
            },
        },
        invalid: {
            color: colors.danger,
        },
    },
};
export var CardDetailsEntry = function (_a) {
    var _b;
    var onNameChange = _a.onNameChange, billingPage = _a.billingPage;
    return (_jsxs(_Fragment, { children: [billingPage && _jsx(PaymentText, __assign({ sub: true }, { children: "Add Card Details" })), _jsxs(ElementTray, __assign({ margin: true }, { children: [_jsx(FieldText, { children: "Cardholder Name" }), _jsx(CardholderNameElement, { type: "text", name: "name", autoFocus: true, defaultValue: "", onChange: onNameChange, placeholder: "eg: John David", style: (_b = stripeElementOptions === null || stripeElementOptions === void 0 ? void 0 : stripeElementOptions.style) === null || _b === void 0 ? void 0 : _b.base })] })), _jsxs(ElementTray, __assign({ row: true }, { children: [_jsxs(ElementTray, __assign({ number: true }, { children: [_jsx(FieldText, { children: "Card Number" }), _jsx(FieldWrapper, { children: _jsx(CardNumberElement, { options: stripeElementOptions }) })] })), _jsx(Spacer, {}), _jsxs(ElementTray, __assign({ col: true }, { children: [_jsx(FieldText, { children: "Expiry Date" }), _jsx(FieldWrapper, { children: _jsx(CardExpiryElement, { options: stripeElementOptions }) })] })), _jsx(Spacer, {}), _jsxs(ElementTray, __assign({ col: true }, { children: [_jsx(FieldText, { children: "Security Code" }), _jsx(FieldWrapper, { children: _jsx(CardCvcElement, { options: stripeElementOptions }) })] }))] }))] }));
};
